
  export const createUrl = (fileName, extension, location) => `${location}/${fileName}.${extension}`;
